var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateSelector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2322 19.4544V13.6589C41.2322 11.5251 39.3888 9.79528 37.1146 9.79528H12.4085C10.1343 9.79528 8.29077 11.5251 8.29077 13.6589V19.4544M41.2322 19.4544V36.8407C41.2322 38.9746 39.3888 40.7044 37.1146 40.7044H12.4085C10.1343 40.7044 8.29077 38.9746 8.29077 36.8407V19.4544M41.2322 19.4544H8.29077M16.5261 5.93164V13.6589M32.9969 5.93164V13.6589",
    stroke: "#272829",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5556 23.3174H13.4379C12.8693 23.3174 12.4084 23.7498 12.4084 24.2833V28.1469C12.4084 28.6804 12.8693 29.1128 13.4379 29.1128H17.5556C18.1241 29.1128 18.585 28.6804 18.585 28.1469V24.2833C18.585 23.7498 18.1241 23.3174 17.5556 23.3174Z",
    fill: "#272829"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8204 23.3174H22.7028C22.1342 23.3174 21.6733 23.7498 21.6733 24.2833V28.1469C21.6733 28.6804 22.1342 29.1128 22.7028 29.1128H26.8204C27.389 29.1128 27.8499 28.6804 27.8499 28.1469V24.2833C27.8499 23.7498 27.389 23.3174 26.8204 23.3174Z",
    fill: "#272829"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0851 23.3174H31.9674C31.3989 23.3174 30.938 23.7498 30.938 24.2833V28.1469C30.938 28.6804 31.3989 29.1128 31.9674 29.1128H36.0851C36.6536 29.1128 37.1145 28.6804 37.1145 28.1469V24.2833C37.1145 23.7498 36.6536 23.3174 36.0851 23.3174Z",
    fill: "#272829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateSelector);
export default __webpack_public_path__ + "static/media/dateSelector.61547ff30acc63407f82eb42b1346cb8.svg";
export { ForwardRef as ReactComponent };